export default {
  hasUser (state) {
    return state.currentUserId !== null
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js